import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const POPULAR_SERVICES = [
  { label: "Covered Patios & Pergolas", to: "/services/patio-covers" },
  { label: "Outdoor Kitchens", to: "/services/outdoor-living" },
  { label: "ADUs & Garage Conversions", to: "/services/adu-construction" },
  { label: "Bathroom Refresh Remodels", to: "/services/bathroom-remodeling" },
  { label: "Kitchen Upgrades", to: "/services/kitchen-remodeling" },
  { label: "Storm-Resistant Roofing", to: "/services/storm-damage-roofing" },
  { label: "Aging-in-Place Modifications", to: "/services/bathroom-remodeling" },
  { label: "Investor / Rental Property Repairs", to: "/services/investor-property-repairs" },
  { label: "Make-Ready Improvements", to: "/services/make-ready-repairs" },
];

export default function HomePopularServices() {
  return (
    <section className="section-pad bg-white">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">Popular in Austin</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Trending Austin-Area Projects</h2>
          <p className="mt-3 text-gray-700">The upgrades Central Texas homeowners are investing in right now.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {POPULAR_SERVICES.map(({ label, to }) => (
            <Link key={label} to={to} className="group p-5 bg-br-paper hover:bg-white border border-gray-200 rounded transition flex items-center justify-between gap-3">
              <span className="font-display tracking-wider uppercase text-sm">{label}</span>
              <ArrowRight size={14} className="text-br-bronze group-hover:translate-x-1 transition" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
